<ng-container
  *ngIf="{
    blockedDates: blockedDates$ | async,
    minDate: minDate$ | async,
    hasPoLine: hasPoLine$ | async,
  } as content"
>
  <ng-template [cxOutlet]="CartOutlets.LIST_ITEM">
    <div class="product-card-row">
      <div class="box-media">
        <product-media [product]="item.product!" format="product"></product-media>
      </div>

      <div class="box-content">
        <ng-template [cxOutlet]="CartOutlets.ITEM_CONFIGURATOR_ISSUES"></ng-template>
        <cx-cart-item-validation-warning [code]="item.product?.code ?? ''"></cx-cart-item-validation-warning>

        @if (!item.product?.isCustom && item.product?.code) {
          <a class="product-name" [routerLink]="['/p', item.product?.code]" target="_blank">
						{{ fixProductName(item.product?.completeName) }}
          </a>
        } @else {
          <span class="product-name">
						{{ fixProductName(item.product?.completeName) }}
          </span>
        }

        <div class="product-intro">
          <div class="product-details">
            @if (item.status) {
              <p>
                <span class="title">{{ 'cart.cartItemListRow.status' | cxTranslate }}: </span><span class="value">{{ item.status }}</span>
              </p>
            }

            @if (item.product?.partNumber) {
              <p>
                <span class="title">{{ 'intro.part' | cxTranslate }}#: </span><span class="value">{{ item.product?.partNumber }}</span>
              </p>
            }

            @if (item.product?.catalogNumber) {
              <p>
                <span class="title">{{ 'intro.catalog' | cxTranslate }}#: </span>
                <span class="value">{{ item.product?.catalogNumber }}</span>
              </p>
            }

            @if (item.product?.customerPartNumber) {
              <p>
                <span class="title">{{ 'intro.customer' | cxTranslate }}#: </span>
                <span class="value">{{ item.product?.customerPartNumber }}</span>
              </p>
            }

            <p>
              <span class="title">{{ 'intro.unitWeight' | cxTranslate }}: </span>
              <span class="value">{{ item.product?.packagingWeight }} {{ item.product?.packagingWeightUom }}</span>
            </p>

            @if (item.invoice) {
              <p>
                <span class="title">{{ 'intro.invoice' | cxTranslate }}: </span>
                <span class="value">{{ item.invoice }}</span>
              </p>
            }

            <p *ngIf="item?.quote">
              <span class="title"> {{ 'cart.cartItems.quoteNumber' | cxTranslate }}: </span>
              <span class="value">{{ item?.quote }}</span>
            </p>

            <!-- for orders only -->
            <p *ngIf="isOrder && item.poLine">
              <span class="title"> {{ 'cart.cartItems.poLineNumber' | cxTranslate }}: </span>
              <span class="value">{{ item?.poLine }}</span>
            </p>

            <div *ngIf="item.product && item.warehouse" class="container-warehouse">
              <check-inventory
                [InProduct$]="convertProduct(item.product)"
                (_onSelectWarehouse)="selectWarehouse($event)"
                [currentWarehouse]="item.warehouse"
                [requestShippingDate]="convertDateToString(item.requestedShipDate)"
                [readonly]="readonly || isProductConfigured"
              ></check-inventory>
            </div>

            @if (readonly) {
              <p>
                <span class="title m-r-4">{{ 'cart.cartItems.quantity' | cxTranslate }}: </span>
                <span class="value">{{ item.quantity }}</span>
              </p>
            }
          </div>

          @if (displayDates) {
            <div class="delivery-date">
              @if (!readonly) {
                <form [formGroup]="formDate">
                  <div class="form-group" [ngClass]="{ disabled: readonly }">
                    <label for="date">
                      <span class="label-content title"
                        >{{ 'cart.cartItems.reqShipDate' | cxTranslate }}

                        <tooltip-icon
                          [content]="'cart.cartItems.reqShipDateInfo' | cxTranslate: { cutOffTime: item.cutoffTime }"
                        ></tooltip-icon>
                      </span>

                      <p-datepicker
                        #inputShipDate
                        formControlName="date"
                        [disabledDates]="content.blockedDates || []"
                        [minDate]="content.minDate"
                        [disabledDays]="[0, 6]"
                        [showTime]="false"
                        (keydown)="handlerKeydownShipDate($event)"
                      />
                    </label>
                  </div>
                </form>
              } @else {
                <div class="d-flex fw-wrap">
                  <span class="title d-flex h-center m-r-4">{{ 'cart.cartItems.reqShipDate' | cxTranslate }}:</span>
                  <span class="value">{{ item?.requestedShipDate | cxDate: 'MM/dd/yyyy' }}</span>
                  <tooltip-icon [content]="'cart.cartItems.reqShipDateInfo' | cxTranslate: { cutOffTime: item.cutoffTime }"></tooltip-icon>
                </div>
              }

              <div *ngIf="item?.inStockEstimatedShipDate; else noStockEstShipDate">
                <p>
                  <span class="title">{{ 'cart.cartItems.estShipDate' | cxTranslate }}: </span>
                  <span class="value">{{ item?.inStockEstimatedShipDate | cxDate: 'MM/dd/yyyy' }} </span>
                  <span class="value">{{ 'cart.cartItems.quantityInStock' | cxTranslate: { quantityInStock: item.quantityInStock } }}</span>
                </p>
                <p>
                  <span class="title text-accent-1">{{ 'cart.cartItems.remainingItems' | cxTranslate }} </span>
                </p>
              </div>

              <ng-template #noStockEstShipDate>
                <p *ngIf="item?.estimatedShipDate">
                  <span class="title">{{ 'cart.cartItems.estShipDate' | cxTranslate }}: </span>
                  <span class="value">{{ item?.estimatedShipDate | cxDate: 'MM/dd/yyyy' }}</span>
                </p>
              </ng-template>

              <p *ngIf="item?.actualShipDate">
                <span class="title">{{ 'cart.cartItems.actualShipDate' | cxTranslate }}: </span>
                <span class="value">{{ item?.actualShipDate | cxDate: 'MM/dd/yyyy' }}</span>
              </p>
            </div>
          }

          @if (isOrder) {
            <div></div>
          }
        </div>

        <!-- Item Quantity -->
        @if (!readonly) {
          <div class="box-qty">
            <div class="label" placement="left" title="{{ 'cart.cartItems.quantityTitle' | cxTranslate }}">
              {{ 'cart.cartItems.quantity' | cxTranslate }}
            </div>

            <div role="cell" class="cx-quantity">
              <div class="cx-value" [class.readonly-value]="readonly">
                <cx-item-counter
                  [control]="quantityControl"
                  [readonly]="checkCounterReadOnly(item, readonly, options)"
                  [allowZero]="true"
                ></cx-item-counter>
              </div>

              @if (isProductConfigured) {
                <tooltip-icon [content]="'cartItems.quantityInfo' | cxTranslate"></tooltip-icon>
              }

              <button
                *ngIf="!readonly"
                (click)="removeItem()"
                [cxAtMessage]="'cart.cartItems.itemRemoved' | cxTranslate"
                [disabled]="quantityControl.disabled"
                attr.aria-label="{{ 'cart.addToCart.removeFromCart' | cxTranslate }}"
                class="btn btn-tertiary cx-remove-btn"
              >
                {{ 'common.remove' | cxTranslate }}
              </button>
            </div>
          </div>
        }

        @if (item.notes) {
          <div class="m-t-12 w-100">
            <p class="title">Notes</p>

            {{ item.notes.length > 50 ? item.notes.substring(0, 50) + '...' : item.notes }}
          </div>
        }

        @if (item.cupons?.length) {
          <div class="m-t-12 w-100">
            <cx-applied-coupons [coupons]="item.cupons || []" [isReadOnly]="true"> </cx-applied-coupons>
          </div>
        }

        @if (item.trackingInfo) {
          <div class="w-100 m-t-12" [innerHTML]="item.trackingInfo"></div>
        }
      </div>

      <div class="last-column">
        <ng-container *ngTemplateOutlet="totalContainer"> </ng-container>

        <div class="actions">
          @if (!readonly) {
            @if (content.hasPoLine) {
              <div class="form-group">
                <label for="">
                  <span class="label-content">
                    {{ 'cart.cartItems.poLineNumber' | cxTranslate }}

                    <tooltip-icon
                      [content]="'cart.cartItems.poLineNumberInfo' | cxTranslate: { cutOffTime: item.cutoffTime }"
                    ></tooltip-icon>
                  </span>

                  <input
                    #input
                    class="form-control"
                    type="text"
                    name="poLine"
                    maxlength="10"
                    placeholder="..."
                    [value]="item.poLine || ''"
                    (change)="updatePOLine(input)"
                  />
                </label>
              </div>
            }
          } @else {
            <p class="m-0">
              <span class="title m-r-4 d-block w-100"> {{ 'cart.cartItems.poLineNumber' | cxTranslate }} </span>
              <span class="value d-block w-100 text-left text-sm-right">
                {{ item.poLine }}
              </span>
            </p>
          }

          @if (item.productConfigurationCode) {
            <button class="btn btn-outline-primary btn-sm btn-config-details" (click)="openModalConfigDetails(item)">
              <span class="material-symbols-outlined d-flex m-r-4"> manufacturing </span>

              View Configuration
            </button>
          }

          @if (!readonly) {
            <button class="btn btn-outline-primary btn-sm" (click)="openModalSeeNotes(item)">
              <span class="d-flex material-symbols-outlined m-r-4"> note_stack </span>
              @if (item.notes) {
                {{ 'cart.cartItems.editNotes' | cxTranslate }}
              } @else {
                {{ 'cart.cartItems.addNotes' | cxTranslate }}
              }
            </button>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #totalContainer>
    <div class="box-price">
      @if (displayValues) {
        <p class="unitary-price">
          <span class="title">{{ 'cart.cartItems.cartUnitPriceTitle' | cxTranslate }}:</span>
          <span class="value">{{ item.basePrice?.formattedValue }}</span>
        </p>
        <p class="total-price">
          <span class="title">{{ 'cart.cartItems.cartTotalPriceTitle' | cxTranslate }}:</span>
          <span class="value">{{ item.totalPrice?.formattedValue }}</span>
        </p>
      }
    </div>
  </ng-template>
</ng-container>
